import { Container } from "components"
import React from "react";
import { Link } from "react-router-dom";

export const InvoiceAndRecept = () => {
    return (
        <Container>
            <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <nav aria-label="breadcrumb" className="ms-4">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link to="#">Manage payments</Link>
              </li>
              <li class="breadcrumb-item active">Invoice & receipt</li>
            </ol>
          </nav>

          <div className="card mb-4 mx-4">
            <h5 className="card-header">Coming soon</h5>
            <div className="card-body">
              


            </div>
            </div>
          </div>
          </div>
        </Container>
    )
}